export const ORG_TYPES = ['regular_school', 'sports_academy', 'college', 'corporate'] as const;
export type OrgType = (typeof ORG_TYPES)[number];

export const YOUTH_ORG_AGES = ['U9', 'U11', 'U13', 'U15', 'U17', 'U19'] as const;
export const COLLEGE_YOUTH_AGES = ['U19'] as const;
export const ADULT_ORG_AGES = ['Senior', 'Para'] as const;
export const ACADEMY_ADULT_AGES = ['Senior', 'Para', 'Coach'] as const;

export function isOrgType(value: string | null | undefined): value is OrgType {
  return ORG_TYPES.includes(String(value || '') as OrgType);
}

export function orgTypeLabel(type: string | null | undefined): string {
  switch (type) {
    case 'college':
      return 'College';
    case 'corporate':
      return 'Corporate';
    case 'sports_academy':
      return 'Sports Academy';
    default:
      return 'Regular School';
  }
}

export function orgNoun(type: string | null | undefined): string {
  switch (type) {
    case 'college':
      return 'college';
    case 'corporate':
      return 'company';
    case 'sports_academy':
      return 'academy';
    default:
      return 'school';
  }
}

export function orgRosterLabel(type: string | null | undefined): string {
  return type === 'corporate' ? 'Employees' : 'Players';
}

export function orgUsesU19Bands(type: string | null | undefined): boolean {
  return type === 'college' || type === 'corporate';
}

export function youthAgesForOrg(type: string | null | undefined): readonly string[] {
  return orgUsesU19Bands(type) ? COLLEGE_YOUTH_AGES : YOUTH_ORG_AGES;
}

export function adultAgesForOrg(type: string | null | undefined): readonly string[] {
  return type === 'sports_academy' ? ACADEMY_ADULT_AGES : ADULT_ORG_AGES;
}

export function allAgesForOrg(type: string | null | undefined): string[] {
  return [...youthAgesForOrg(type), ...adultAgesForOrg(type)];
}

export function defaultAgeForOrg(type: string | null | undefined): string {
  return orgUsesU19Bands(type) ? 'U19' : 'U13';
}

export function youthBandLabel(type: string | null | undefined): string {
  return orgUsesU19Bands(type) ? 'U19' : 'U9–U19';
}
